import { useEffect, useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useTurmaSearchDropdown } from '../../../hooks/useTurmaSearchDropdown';

export interface TurmaAutocompleteProps {
  /** ID (`classStudentId`) da turma selecionada; `null` quando nada. */
  readonly value: number | null;
  /** Rótulo da turma selecionada. */
  readonly selectedLabel?: string;
  /** Notifica o novo ID de turma e seu rótulo (`null`/`''` ao limpar). */
  readonly onChange: (id: number | null, label: string) => void;
  /** Restringe a busca ao curso selecionado no campo "Curso" do mesmo modal. */
  readonly courseId?: number;
  readonly label: string;
  readonly placeholder: string;
  readonly hasError?: boolean;
}

/**
 * Autocomplete de Turma para o modal "Adicionar Turma" (busca server-side via
 * {@link useTurmaSearchDropdown}, base compartilhada `LookupAutocompleteView`).
 */
export function TurmaAutocomplete({
  value,
  selectedLabel: selectedLabelProp = '',
  onChange,
  courseId,
  label,
  placeholder,
  hasError,
}: TurmaAutocompleteProps) {
  const [search, setSearch] = useState('');
  const [inputText, setInputText] = useState(selectedLabelProp);
  const { options, isQuerySuccess } = useTurmaSearchDropdown(search, courseId);

  useEffect(() => {
    setInputText(selectedLabelProp);
  }, [selectedLabelProp]);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value !== null ? String(value) : ''}
      selectedLabel={inputText}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      hasError={hasError ?? false}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id ? Number(id) : null, itemLabel);
        setInputText(itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange(null, '');
        setInputText('');
        setSearch('');
      }}
    />
  );
}
